/**
 * Created by olga on 25.06.2025
 */

UnitView.prototype.addUpgradeAnimation = function (callback) {
    const animationName = this.unit.getData().upgradeAnimation;
    const upgradeAnimation = bundles.homefix_animations.jsons[`${animationName}`];
    if (!upgradeAnimation) {
        callback();
        return;
    }

    const spine = new cleverapps.Spine(upgradeAnimation);
    spine.setAlignment({ align: "center" }, { align: "center" });
    spine.setAnimation(0, "animation", false);
    this.addChild(spine);
    spine.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode(spine));
    spine.setCompleteListenerRemove(callback);
};